import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './LoadingDots.module.css.js';

function LoadingDots() {
  return jsxs("div", {
    className: "flex gap-2xs",
    children: [jsx("div", {
      className: clsx('h-2sm w-2sm rounded-full bg-green', styles.dot)
    }), jsx("div", {
      className: clsx('h-2sm w-2sm rounded-full bg-green', styles.dot)
    }), jsx("div", {
      className: clsx('h-2sm w-2sm rounded-full bg-green', styles.dot)
    })]
  });
}

export { LoadingDots };
